<template>
    <span>
        <button type="button" class="btn btn-outline-danger btn-sm mr-1 mb-1" data-toggle2="tooltip" data-placement="top" title="Cancelar Marcação"
            @click="$parent.cancelarAtendimento(hor.marcacao)" 
            v-if="( hor.marcacao.ch_estado_marcacao == 'A' || hor.marcacao.ch_estado_marcacao == 'B' ) && !hor.marcacao.id_atendimento && hor.marcacao.item_status.valor != 'faltoso'">
            <i class="fas fa-minus-circle"></i>
        </button>

        <button type="button" class="btn btn-outline-warning btn-sm mr-1 mb-1" data-toggle2="tooltip" data-placement="top"
            title="Remarcar" @click="$parent.remarcar (hor.marcacao)">
            <i class="fas fa-retweet"></i>
        </button>

        <a class="btn btn-outline-info btn-sm mr-1 mb-1" data-toggle2="tooltip" data-placement="top" title="Confirmação pelo Telegram"
            href="#" :disabled="hor.marcacao.enviando" @click.prevent="$parent.confirmar_telegram (hor.marcacao)" 
            v-if="iq != 'Confirmada' && hor.marcacao.telegram_chat_id">
            <div class="spinner-border spinner-border-sm" role="status" v-if="hor.marcacao.enviando">
                <span class="sr-only">Loading...</span>
            </div>
            <i class="fab fa-telegram-plane" aria-hidden="true" v-else></i>
        </a>

        <!-- confirma kualiz -->
        <a class="btn btn-outline-success btn-sm mr-1 mb-1" data-toggle2="tooltip" data-placement="top" title="Confirmação pelo WhatsApp"
            href="#"
            @click="$parent.kualiz_open_chat (hor.marcacao)"
            v-if="( hor.marcacao.ch_estado_marcacao == 'A' || hor.marcacao.ch_estado_marcacao == 'B' ) && iq != 'Confirmada' && !hor.marcacao.id_atendimento && hor.marcacao.item_status.valor != 'faltoso' && $parent.is_kualiz">
            <i class="fab fa-whatsapp"></i>
        </a>

        <a class="btn btn-outline-success btn-sm mr-1 mb-1" data-toggle2="tooltip" data-placement="top" title="Confirmação pelo WhatsApp"
            :href="$parent.whatsapp_link (hor.marcacao)" :target="$parent.whatsapp_link (hor.marcacao).substr(0,1) == 'j' ? '' : '_blank'" 
            @click="$parent.tooltip_hide ()"
            v-if="( hor.marcacao.ch_estado_marcacao == 'A' || hor.marcacao.ch_estado_marcacao == 'B' ) && iq != 'Confirmada' && !hor.marcacao.id_atendimento && hor.marcacao.item_status.valor != 'faltoso' && !$parent.is_kualiz">
            <i class="fab fa-whatsapp"></i>
        </a>

        <button type="button" class="btn btn-outline-success btn-sm mr-1 mb-1" data-toggle2="tooltip" data-placement="top" title="Confirmado" @click="$parent.confirmar (hor.marcacao, 'C')" v-if="iq != 'Confirmada'">
            <i class="fas fa-phone"></i>
            <span class="badge badge-light" v-if="hor.marcacao.ch_estado_marcacao == 'B' && $parent.sem_resposta_count(hor.marcacao, 2)">{{ $parent.sem_resposta_count(hor.marcacao, 2) }}</span>
        </button>

        <button type="button" class="btn btn-outline-secondary btn-sm mr-1 mb-1" data-toggle2="tooltip" data-placement="top"
            :title="'Sem resposta (' + $parent.sem_resposta_count(hor.marcacao) + ')'" @click="$parent.confirmar (hor.marcacao, 'S')"
            v-if="iq != 'Confirmada'">
            <i class="fas fa-phone-slash"></i>
            <span class="badge badge-light" v-if="hor.marcacao.ch_estado_marcacao == 'B' &&  $parent.sem_resposta_count(hor.marcacao)">{{ $parent.sem_resposta_count(hor.marcacao) }}</span>
        </button>

        <button type="button" class="btn btn-outline-primary btn-sm mr-1 mb-1"
            data-toggle2="tooltip" data-placement="top" title="Adicionar marcação" @click="$parent.adcionar_marcacao(hor.marcacao)"
            v-if="iq != 'Confirmada'">
            <i class="fa-regular fa-calendar-plus"></i>
        </button>

        <button type="button" class="btn btn-sm mr-1 mb-1" :class="( hor.marcacao.orcamento && hor.marcacao.orcamento.id_pagamento_atendimento ) ? 'btn-primary' : 'btn-outline-primary'"
            data-toggle2="tooltip" data-placement="top" title="Orçamento" @click="gerar_orcamento(hor.marcacao)" v-if="hor.marcacao && hor.marcacao.fl_particular">
            <i class="fas fa-dollar-sign"></i> 
            <span class="ml-2" v-if="hor.marcacao.id_orcamento">#{{ hor.marcacao.id_orcamento }}</span>
        </button>
    </span>
</template>

<script>
export default {
    props: ['hor', 'iq'],

    methods: { 
        gerar_orcamento(marcacao) { 
            this.$nextTick(() => { 

                this.$router.push(
                    {
                        name: 'orcamento', 
                        params: { 
                            origem: marcacao
                        } 
                    }
                );

            });
        },
    }
}
</script>
